const modalBgColor = '#f1f1f1';
const modalBorderColor = '#ccc';
const highlightColor = 'rgba(100, 175, 230, 0.8)';
const successColor = 'rgba(0, 255, 45, 0.5)';

export { modalBgColor, modalBorderColor, highlightColor, successColor };



// WEBPACK FOOTER //
// ./src/styles/colours.js